import api from '../../../App/socket';

export const updateWWYMLead = (userId, leadId) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Update',
    options: {
        update: {
            'trade.is_trade': false,
            'trade.converted_by': userId,
            'trade.trade_created_date': new Date(),
        },
        where: {
            _id: leadId,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/assign_wwym_lead_request.js